import $ from 'jquery';

$('.square-teaser__item').on('click', function(e) {
    if($(this).hasClass('square-teaser__item--visible')) {
        $(this).removeClass('square-teaser__item--visible');
    }
    else {
        e.preventDefault();
        $('.square-teaser__item').removeClass('square-teaser__item--visible');
        $(this).addClass('square-teaser__item--visible');
    }
});

$('.square-teaser__item').on('mouseenter', function() {
    if($(window).width() >= 1280) {
        if($(this).hasClass('square-teaser__item--visible')) {
            $(this).removeClass('square-teaser__item--visible');
        }
        else {
            $('.square-teaser__item').removeClass('square-teaser__item--visible');
            $(this).addClass('square-teaser__item--visible');
        }
    }
});

$('.square-teaser__item').on('mouseleave', function() {
    if($(window).width() >= 1280) {
        $('.square-teaser__item').removeClass('square-teaser__item--visible');
    }
});
